module.exports = __webpack_public_path__ + "static/img/ruby.7be6dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/ruby.jpg
// module id = FWuH
// module chunks = 1